import * as React from "react";

const CustomArrowUp: React.FC = () => {
    return (
        <svg
            width="16"
            height="22"
            viewBox="0 0 16 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.6214 3.99268L8.6214 21.8089H6.72625L6.72626 3.99268L1.6426 9.07634L0.302328 7.73606L7.67383 0.364563L15.0453 7.73606L13.7051 9.07634L8.6214 3.99268Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(CustomArrowUp);
